import { render, staticRenderFns } from "./data.component.html?vue&type=template&id=b03ab2b6&scoped=true&"
import script from "./data.component.ts?vue&type=script&lang=ts&"
export * from "./data.component.ts?vue&type=script&lang=ts&"
import style0 from "./data.component.scss?vue&type=style&index=0&id=b03ab2b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03ab2b6",
  null
  
)

export default component.exports